import * as util from "lib/util.js";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import "@ui5/webcomponents/dist/Badge";

class KbIpcCartButton extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.state.partcart.length > 0) {
      this.myRender();
    }
  }

  myRender() {
    render(this.ipcCartButtonTemplate(), this.shadowRoot);
  }

  ipcCartButtonTemplate() {
    return html`
      <style>
        span {
          display: flex;
        }
        iron-icon {
          margin-top: 5px;
        }
      </style>
      <span @click="${this._openCart.bind(this)}">
        <iron-icon icon="vaadin:cart"></iron-icon>
        ${this.state.partcart.length}
      </span>
    `;
  }

  _openCart(e) {
    storeInstance.dispatch("setState", {
      property: "cart_dialog_open",
      value: "open",
    });
  }
}

customElements.define("kb-ipc-cart-button", KbIpcCartButton);
